<script setup lang="ts">
defineProps<{ options: { value: string; label?: string; count?: number }[] }>();
const modelValue = defineModel<string[]>({ required: true });
</script>

<template>
  <ul class="">
    <li v-for="(option, i) of options" :key="i">
      <label>
        <input v-model="modelValue" type="checkbox" :value="option.value" class="focus-default">
        {{ option.label || option.value }} <span v-if="option.count !== undefined" class="text-xs text-muted">({{ option.count }})</span>
      </label>
    </li>
  </ul>
</template>
